import { ALLLocations } from 'models/CompanySetup/allLocations.model';
import React, { FC, createContext, useContext, useState } from 'react';
import ParentCompanySetupService from 'services/ParentCompanySetup/parentCompanySetup.service';

type LocationsDataContextType = {
  locationTableData: ALLLocations | null;
  setLocationTableData: (data: ALLLocations | null) => void;
  loading: boolean;
  fetchAllLocations: (params: {
    year?: number;
    page?: number;
    search?: string;
    sort_by?: string;
    sort_dir?: string;
  }) => void;
  clearLocationContext: () => void;
};

export const LocationsDataContext = createContext<LocationsDataContextType>({
  locationTableData: null,
  loading: false,
  setLocationTableData: () => {},
  fetchAllLocations: () => {},
  clearLocationContext: () => {},
});

// Custom hook to use the context
export const useLocationsDataContext = () => {
  const context = useContext(LocationsDataContext);
  if (!context) {
    throw new Error(
      'useLocationsDataContext must be used within a LocationsDataProvider'
    );
  }
  return context;
};

// Provider component
export const LocationsDataProvider: FC = ({ children }) => {
  const { fetchAllLocations, loading } = ParentCompanySetupService();

  const [locationTableData, setLocationTableData] =
    useState<ALLLocations | null>(null);

  const clearLocationContext = () => setLocationTableData(null);

  return (
    <LocationsDataContext.Provider
      value={{
        locationTableData,
        setLocationTableData,
        loading,
        fetchAllLocations,
        clearLocationContext,
      }}>
      {children}
    </LocationsDataContext.Provider>
  );
};
